import { useMemo } from 'react'
import useLoyaltyPurchasePointsOffers from 'loyalty/hooks/useLoyaltyPurchasePointsOffers'
import loyaltyPointsPurchasePickBestOffer from 'loyalty/lib/loyaltyPointsPurchasePickBestOffer'

interface ReturnType {
  offer: App.LoyaltyPurchasePointsOffer | undefined
  fetching: boolean
}

/**
 * Resolves the buy-points offer that best matches a member's points deficit,
 * delegating selection to `loyaltyPointsPurchasePickBestOffer`.
 */
function useLoyaltyPointsPurchaseBestOffer(deficit: number): ReturnType {
  const { offers, fetching } = useLoyaltyPurchasePointsOffers()

  const offer = useMemo(
    () => loyaltyPointsPurchasePickBestOffer(offers, deficit),
    [offers, deficit],
  )

  return { offer, fetching }
}

export default useLoyaltyPointsPurchaseBestOffer
